// Session hooks. The server is the authority (a VIEWER mutation is
// refused 403 MOCK_FORBIDDEN regardless); the console disables mutating
// controls up front so a viewer is never invited to try.
import { useQuery } from "@tanstack/react-query";
import { fetchMeOrNull, keys } from "./queries";

export function useMe() {
  return useQuery({ queryKey: keys.me(), queryFn: fetchMeOrNull, staleTime: 30_000 });
}

export function useCanMutate(): boolean {
  const me = useMe();
  return me.data?.role === "OPERATOR";
}
